import { GridSize } from '../../common/components/UI/SideModal/SideModal';

export const BUSINESS_EVENT = 'Business Event';

export const EVENT_FORM_PARAM = {
  eventId: 'eventId',
  eventName: 'eventName',
  schemaName: 'schemaName',
  category: 'category',
  version: 'version',
  description: 'description',
  avroSchema: 'avroSchema'
};

export const SORT_LABELS = {
  EVENTNAME: 'eventName',
  STATUS: 'status',
  LASTMODIFIED: 'updatedTimestamp'

};

export enum EventLabels {
  EVENT_NAME = 'eventName',
  EVENT_STATUS = 'status',
  LAST_MODIFIED = 'updatedTimestamp',
  ACTION_BTN = 'actionBtn',
  CREATED_BY = 'createdBy',
  UPDATED_BY = 'updatedBy'
}

export const SORT_STRINGS = {
  LAST_MODIFIED: 'updatedTimestamp,DESC',
  ASC: 'ASC',
  DESC: 'DESC'
};

export const EVENT_LIST_WRAPPER_STR = {
  DATE_STR: 'date',
  LAST_MODIFIED_STR: 'Last Modified:',
  START_DATE_STR: 'start_date',
  LAST_MODIFIED_FROM: 'Last Modified From:',
  END_DATE: 'end_date',
  LAST_MODIFIED_TO: 'Last Modified To:',
  STATUS_STR: 'status',
  FILE_TYPE: 'application/zip',
  SPLIT_STR: 'filename="',
  ZIP_EXT: '.zip'
};

export const EVENT_ROUTE = {
  CREATE_EVENT_ROUTE: '/control-plane/events/createEvent',
  UPLOAD_FILES_ROUTE: '/control-plane/events/upload-files',
  IMPORT_ROUTE: '/control-plane/events/import',
  EVENTS_VIEW_ROUTE: '/control-plane/events/view/',
  EVENTS_EDIT_ROUTE: '/control-plane/events/edit/',
  ASSOCIATIONS_ROUTE: '/control-plane/events/event-association/',
};

export const EVENT_MODES = {
  EDIT: 'edit',
  VIEW: 'view'
};

export const SIDE_MODAL_CONSTANTS = {
  REASON: 'Reason For Return',
  BREADKPOINT: 'xs',
  ALIGN: 'right'
};

export const SIDE_MODAL_BREAKPOINT: keyof GridSize = 'xs';

export const COMMENT_HISTORY_MODAL = {
  DATE_FORMAT: 'DD/MM/YYYY HH:mm:ss',
  GENERATE_INITIALS: 'AB'
};

export const IMPORT_EVENT = {
  FILE_TYPE: 'application/zip',
  ZIP_EXT: '.zip',
  ZIP_FILE: 'zip-file'
};

export const IMPORT_FILE_STATUS_CLASSTYPES = {
  SUCCESS: 'active',
  FAILED: 'returned',
  INACTIVE: 'inactive'
};

export const TIMER = 50000;

// schemadetailsForms
export const STR = 'string';
export const SCHEMA_NAME_MAXLENGTH = '101';

export const eventTypes = [{ eventType: 'Platform Event' }, { eventType: 'Business Event' }];

export const EVENT_DETAILS_MAX_LENGTH = {
  eventName: 51,
  eventDescription: 501,
};

export const EVENT_ASSOCIATION_TABS = {
  SOURCES: 'sources',
  SERVICES: 'services'
};
